import { forwardRef, memo, useCallback } from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
// SCSS imports
import { tabItem, clickable, current, currentFirst, first, other } from './QuickTourTab.module.scss';

type QuickTourTabProps = {
  readonly tab: string;
  readonly selected?: boolean;
  readonly isFirst?: boolean;
  readonly disabled?: boolean;
  readonly onClick: (tab: string) => void;
};

const QuickTourTab = forwardRef<HTMLDivElement, QuickTourTabProps>(({
  tab,
  selected = false,
  isFirst = false,
  disabled = false,
  onClick
}, ref) => {
  const handleClick = useCallback(() => onClick(tab), [onClick, tab]);
  return (
    <Grid
        ref={ref}
        container
        size={4}
        alignItems="center"
        justifyContent="center"
        onClick={disabled ? undefined : handleClick}
        className={clsx(tabItem, {
          [clickable]: !disabled,
          [current]: !isFirst && selected,
          [currentFirst]: isFirst && selected,
          [first]: isFirst && !selected,
          [other]: !isFirst && !selected
        })}
    >
      <Typography variant={selected ? 'body1' : 'h5'}>
        <FormattedMessage id={`tour.tab.${tab}`}/>
      </Typography>
    </Grid>
  );
});

QuickTourTab.displayName = 'QuickTourTab';

export default memo(QuickTourTab);
